import { render, staticRenderFns } from "./LessonBooksWidget.vue?vue&type=template&id=7f59aab6&scoped=true"
import script from "./LessonBooksWidget.vue?vue&type=script&lang=js"
export * from "./LessonBooksWidget.vue?vue&type=script&lang=js"
import style0 from "./LessonBooksWidget.vue?vue&type=style&index=0&id=7f59aab6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f59aab6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f59aab6')) {
      api.createRecord('7f59aab6', component.options)
    } else {
      api.reload('7f59aab6', component.options)
    }
    module.hot.accept("./LessonBooksWidget.vue?vue&type=template&id=7f59aab6&scoped=true", function () {
      api.rerender('7f59aab6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/LessonBooksWidget.vue"
export default component.exports